import { Typography, Button } from "antd";

export interface ViewReportCardProps {
  readonly title: string;
  readonly text: string;
  readonly btnName: string;
  readonly btnAction: () => void;
}

// PD-02 Stage pages — report CTA. Branded teal button with hover lift
// (styles come from index.scss `.ant-btn-primary`). Soft gradient background
// so the card stands out from the plain page.
function ViewReportCard(props: ViewReportCardProps) {
  return (
    <section
      className="m-0 flex flex-1 flex-col items-center justify-between gap-6 rounded-2xl py-12 px-4"
      style={{
        background:
          "linear-gradient(135deg, rgba(232,246,245,0.6) 0%, rgba(255,255,255,0.9) 100%)",
        boxShadow: "0 4px 14px rgba(20, 160, 152, 0.08)",
      }}
    >
      <Typography.Title
        level={3}
        className="m-0 p-0 tracking-tight !text-[#0d7a73]"
      >
        {props.title.toUpperCase()}
      </Typography.Title>
      <Typography.Text className="w-1/2 text-center text-xl tracking-wide text-slate-700">
        {props.text}
      </Typography.Text>
      <Button
        type="primary"
        size="large"
        className="h-14 min-w-[180px] text-xl tracking-wide"
        onClick={props.btnAction}
      >
        {props.btnName.toUpperCase()}
      </Button>
    </section>
  );
}

export default ViewReportCard;
